import React, { useEffect, useState } from 'react';
import { TextField, Skeleton, Box, FormHelperText, Stack } from '@mui/material';
import { useObjectContext } from '@/hooks/useObjectContext';
import { minimalInputTheme } from '@/app/theme';
import { useDispatch } from 'react-redux';
import { ticketsApi, useUpdateInsightClaimMutation } from '@/features/claims/ticketsApi';
import { useUpdateDealRowMutation } from '@/features/deals/dealsApi';

export const ClaimNumberField = ({ minimal = true }) => {
	const dispatch = useDispatch();

	// Insight caps InsurerClaimsRef at 30 characters
	const MAX_LENGTH = 30;

	const { dealRow, dealId } = useObjectContext();

	const [claimNumber, setClaimNumber] = useState(dealRow?.claimNumber ?? '');
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		setClaimNumber(dealRow?.claimNumber ?? '');
	}, [dealRow?.claimNumber]);


	const [updateInsightClaim] = useUpdateInsightClaimMutation();
	const [updateDealRow] = useUpdateDealRowMutation();

	const updateClaimNumber = async () => {
		// if (claimNumber.trim().length > 0) {
		setIsLoading(true);
		try {
			await updateDealRow({
				dealId,
				docId: dealRow?.id,
				properties: {
					claimNumber,
				},
			}).unwrap();

			await updateInsightClaim({
				dealId,
				properties: {
					InsurerClaimsRef: claimNumber,
				},
			}).unwrap();
			const uppercaseType = (dealRow?.objectType ?? '').toUpperCase();
			dispatch(
				ticketsApi.util.invalidateTags([
					{ type: `${uppercaseType}S`, id: 'LIST' },
					{ type: uppercaseType, id: dealId },
				]),
			);
		} catch (error) {
			console.error('Error updating claim number', dealRow, error);
		} finally {
			setIsLoading(false);
		}
		// }
	};

	return (
		<>
			{!dealRow ? (
				<Skeleton animation='wave' width='55%' height='2em' />
			) : (
				<Stack width={'100%'}>
					<TextField
						fullWidth
						disabled={isLoading}
						variant={minimal === true ? 'standard' : 'outlined'}
						sx={minimal === true ? minimalInputTheme : {}}
						className={minimal === true ? 'minimal-input' : null}
						value={claimNumber}
						onChange={(event) => setClaimNumber(event.target.value)}
						onBlur={updateClaimNumber}
						inputProps={{ maxLength: MAX_LENGTH }}
					/>
					<Box>
						<FormHelperText
							sx={{
								textAlign: 'right',
								mr: '14px',
								...(claimNumber.length == MAX_LENGTH && { fontWeight: 'bold' }),
							}}
						>
							{`${claimNumber.length}/${MAX_LENGTH}`}
						</FormHelperText>
					</Box>
				</Stack>
			)}
		</>
	);
};
